import { KnownHubDetailsDtoType } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Grid } from '@mui/material';
import { Alert } from '@mui/material';
import { UseFormReturn } from 'react-hook-form';
import { Dropdown } from '../../../../../../ui/components/pure/dropdown/dropdown.component';
import { FormControl } from '../../../../../../ui/components/pure/form-control/form-control.component';
import { HubDetails } from '../../../../../lockers/models/hub-details.model';
import { DeliverNowModalForm } from '../delivery-action.hook';

export function DeliverNowModalHubSelection(props: {
  selectedHub?: HubDetails;
  showHubSelection: boolean;
  hubSelectOptions: { value: string; label: string }[];
  deliveryContainerSelectOptions: { value: string; label: string }[];
  form: UseFormReturn<DeliverNowModalForm, any, DeliverNowModalForm>;
}) {
  const deliveryContainerID = props.form.watch('deliveryContainerID');

  return (
    <>
      <Grid container spacing={2}>
        <>
          {props.showHubSelection ? (
            <Grid size={12}>
              <FormControl
                control={props.form.control}
                name="hubID"
                required
                Component={Dropdown}
                ComponentProps={{
                  fullWidth: true,
                  textFieldDesktopWidth: '100%',
                  dropdownVariant: 'floating' as const,
                  placeholder: 'Hub',
                  menuItems: props.hubSelectOptions
                }}
              />
            </Grid>
          ) : null}
          {(props.selectedHub?.type === KnownHubDetailsDtoType.SpacesHub ||
            props.selectedHub?.type === KnownHubDetailsDtoType.KiosklessSpacesHub) && (
            <Grid size={12}>
              <FormControl
                control={props.form.control}
                name="deliveryContainerID"
                required
                Component={Dropdown}
                ComponentProps={{
                  fullWidth: true,
                  textFieldDesktopWidth: '100%',
                  dropdownVariant: 'floating' as const,
                  placeholder: 'Stored in space',
                  menuItems: props.deliveryContainerSelectOptions
                }}
              />
              {deliveryContainerID ? (
                <Alert severity="info" style={{ marginTop: '20px' }}>
                  Please place the item and press confirm to send notifications. The delivery can be transferred to
                  another space later if required.
                </Alert>
              ) : null}
            </Grid>
          )}
          {props.selectedHub?.type === KnownHubDetailsDtoType.LockersHub && (
            <Grid size={12}>
              {' '}
              <Alert severity="info" style={{ marginTop: '20px' }}>
                You must be at the {props.selectedHub?.name || ''} lockers to continue. Please ensure no one else is
                using the kiosk.
              </Alert>
            </Grid>
          )}
        </>
      </Grid>
    </>
  );
}
